import React, { useEffect, useState } from "react";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";

import {
  MdExpandLess,
  MdExpandMore,
  MdAddCircle,
  MdArrowDropDownCircle,
} from "react-icons/md";
import styled from "styled-components";
import { useFieldArray } from "react-hook-form";

import { request } from "../../../../services/helpers";
import { WatchItemsList } from "./WatchItemsList";

const StyledButton = styled(Button)`
  font-size: 1em;
  border: 2px solid palevioletred;
`;

const InvoiceItemsList = (props) => {
  const [productList, setProductList] = useState([]);
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const {
    register,
    control,
    errors,
    setError,
    watch,
    getValues,
    setValue,
  } = props;
  //   const { register, getValues, watch, handleSubmit, control } = useForm();
  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "itemList", // unique name for your Field Array
    // keyName: "id", default to "id", you can change the key name
  });

  useEffect(() => {
    const fetchData = async () => {
      const res = await request.get("/products");
      if (res.data) setProductList(res.data);
      // if (res.status === 200) console.log(res.data);
    };

    fetchData();
  }, []);

  const addNewItem = (item) => {
    // console.log("AddItem: ", item);
    setProductList((prevProducts) => [...prevProducts, item]);
  };

  const appendNewItem = () => {
    append({ name: "itemList" });
    if (!open) setOpen(true);
  };

  //Item-Amount-watcher Initializer
  let watchProduct = [];
  fields.forEach((item, index) => {
    watchProduct[index] = watch(`itemList[${index}].amount`);
  });

  return (
    <div>
      <Paper elevation={1} className="p-2">
        <ListItem
          className="w-full flex flex-row align-center justify-between pl-2 ml-0"
          // button
          // onClick={handleClick}
        >
          <div className="flex flex-row items-center">
            <Badge
              badgeContent={fields.length}
              color="secondary"
              className="mr-5"
            >
              <label
                className="block tracking-wide text-black font-display text-small leading-5 font-medium mr-3"
                htmlFor="included-items-list"
              >
                Included Items List
              </label>
            </Badge>
          </div>
          <div className="flex flex-row items-center">
            <StyledButton
              className="hidden sm:flex mr-5 outline-none border-gray-100"
              onClick={appendNewItem}
              startIcon={<MdAddCircle />}
            >
              <span className="font-display text-xs md:text-sm">Add Item</span>
            </StyledButton>
            {open ? (
              <IconButton
                color="primary"
                className="outline-none"
                onClick={handleClick}
              >
                <MdExpandLess size="1em" />
              </IconButton>
            ) : (
              <IconButton className="outline-none" onClick={handleClick}>
                <MdExpandMore size="1em" />
              </IconButton>
            )}
          </div>
        </ListItem>
        <Divider />
        <List aria-labelledby="Items List">
          <Collapse in={open} timeout="auto">
            <ul>
              {fields.map((item, index) => {
                return (
                  <WatchItemsList
                    key={item.id}
                    item={item}
                    index={index}
                    append={append}
                    remove={remove}
                    register={register}
                    control={control}
                    errors={errors}
                    //   watch={watch}
                    getValues={getValues}
                    setValue={setValue}
                    watchProduct={watchProduct}
                    productList={productList}
                    onAddNewItem={addNewItem}
                  />
                );
              })}
            </ul>
          </Collapse>
        </List>
        <div>
          {fields.length === 0 ? (
            <div className="w-full flex flex-row justify-center items-center mb-2">
              <StyledButton
                className="outline-none border-0"
                onClick={appendNewItem}
                endIcon={<MdAddCircle />}
              >
                <label className="text-center block tracking-wide text-black font-display text-small sm:mr-2">
                  Looks like an empty list!
                </label>
                {/* <IconButton aria-label="add-item" onClick={appendNewItem}>
                  <MdAddCircle />
                </IconButton> */}
              </StyledButton>
            </div>
          ) : open ? (
            <StyledButton
              className="outline-none border-gray-100"
              onClick={appendNewItem}
              endIcon={<MdAddCircle />}
            >
              <span className="font-display text-xs md:text-sm">Add Item</span>
            </StyledButton>
          ) : (
            <div className="w-full flex flex-row justify-center items-center mb-2">
              <StyledButton
                className="outline-none border-0"
                onClick={handleClick}
                endIcon={<MdArrowDropDownCircle />}
              >
                <label className="text-center block tracking-wide text-black font-display text-small sm:mr-2">
                  Click to see the items added
                </label>
                {/* <IconButton
                aria-label="expand"
                onClick={handleClick}
                className="outline-none"
              >
                <MdArrowDropDownCircle />
              </IconButton> */}
              </StyledButton>
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default InvoiceItemsList;
